import SignInSignUpForm from '@/components/SignInSignUpForm';
import api from '@/lib/api';
import _ from 'lodash';
import { Formik } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { object, string } from 'zod';
import { toFormikValidationSchema } from 'zod-formik-adapter';

export default function ResetPassword() {
	const [isSubmitting, setIsSubmitting] = React.useState(false);
	const resetPasswordSchema = object({
		email: string().email('Please enter a valid email'),
	}).required({ email: true });
	const [searchParams] = useSearchParams();

	return (
		<Formik
			initialValues={{ email: '', password: '' }}
			onSubmit={async (values) => {
				setIsSubmitting(true);
				try {
					await api.post('/auth/forgot-password', {
						email: values.email,
					});
					toast.success(
						'A link was sent to your email to change your password'
					);
				} catch (err: any) {
					const msg =
						`${err}`.split(':')?.[1]?.trim() ||
						'Something went wrong';
					toast.error(_.startCase(msg));
				} finally {
					setIsSubmitting(false);
				}
			}}
			validationSchema={toFormikValidationSchema(resetPasswordSchema)}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				setFieldError,
			}) => (
				<SignInSignUpForm
					values={values}
					handleChange={handleChange}
					handleBlur={handleBlur}
					handleSubmit={handleSubmit}
					mode={'forgotPassword'}
					setMode={(nextMode) => {
						const target =
							nextMode === 'signUp' ? '/signup' : '/signin';
						const qs = searchParams.toString();
						window.location.href = qs ? `${target}?${qs}` : target;
					}}
					isSubmitting={isSubmitting}
					errors={errors}
					touched={touched}
					setFieldError={setFieldError}
				/>
			)}
		</Formik>
	);
}
